import { KeyboardDoubleArrowDown, KeyboardDoubleArrowUp } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import WExpirateIcon from "src/components/shared/icon/WExpirateIcon";
import WImportIcon from "src/components/shared/icon/WImportIcon";
import WRemoveIcon from "src/components/shared/icon/WRemoveIcon";
import { DASHBOARD_STATISTIC } from "src/constant";
import useAuthGlobal from "src/context/useAuthGlobal";
import useRedirect from "src/helper/direct";
import useWarehouseTransferSummary from "src/hooks/warehouse-transfer/useWarehouseTransferSummary";
const textConfig = { fontSize: "14px", fontWeight: "bold" };
const cardHoverStyles = {
  cursor: "pointer",
  borderRadius: "10px",
  flex: 1,
  p: "17px 24px",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
  },
};

export default function InventoryStatistic() {
  const { userMe } = useAuthGlobal();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);

  const { data: statistic } = useWarehouseTransferSummary({
    warehouse: userMe?.currentWarehouse?._id,
  });
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
      <Button
        onClick={() => setOpen((prev) => !prev)}
        endIcon={!open ? <KeyboardDoubleArrowUp fontSize="16px" /> : <KeyboardDoubleArrowDown fontSize="16px" />}
        sx={{ m: "0 0 0 auto", fontSize: "10px" }}
      >
        {!open ? "Ẩn" : "Mở"} thống kê
      </Button>
      {!open && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
            pr: "12px",
          }}
        >
          <Box
            onClick={() => redirect("/warehouse-management/inventory-in?tab=history-in")}
            sx={{
              ...cardHoverStyles,
              background: "var(--success)",
              "&:hover": {
                ...cardHoverStyles["&:hover"],
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color: "var(--success-txt)",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {statistic?.data?.warehouse?.[DASHBOARD_STATISTIC.totalImport] ?? statistic?.data?.[DASHBOARD_STATISTIC.totalImport]}
              </Typography>
              <WImportIcon />
            </Box>
            <Typography sx={{ ...textConfig }}>Y/C Nhập kho</Typography>
          </Box>

          <Box
            onClick={() => redirect("/warehouse-management?tab=inventory-out-remove")}
            sx={{
              ...cardHoverStyles,
              background: "var(--reject)",
              "&:hover": {
                ...cardHoverStyles["&:hover"],
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color: "var(--reject-txt)",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {statistic?.data?.warehouse?.[DASHBOARD_STATISTIC.totalRemove] ?? statistic?.data?.[DASHBOARD_STATISTIC.totalRemove]}
              </Typography>
              <WRemoveIcon />
            </Box>
            <Typography sx={{ ...textConfig }}>Y/C Xuất bỏ hàng hoàn</Typography>{" "}
          </Box>

          <Box
            onClick={() => redirect("/warehouse-management/inventory?tab=inventory")}
            sx={{
              ...cardHoverStyles,
              background: "var(--pending)",
              "&:hover": {
                ...cardHoverStyles["&:hover"],
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color: "var(--pending-txt)",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {statistic?.data?.warehouse?.[DASHBOARD_STATISTIC.totalNearExpire] ?? statistic?.data?.[DASHBOARD_STATISTIC.totalNearExpire]}
              </Typography>
              <WExpirateIcon />
            </Box>
            <Typography sx={{ ...textConfig }}>Lô sản phẩm cận date</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}
